import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { ArrowLeft, BookOpen } from 'lucide-react';
import { motion } from 'framer-motion';

export const AboutSection = ({ onBack }) => {
  const { t } = useLanguage();

  return (
    <div className="px-4 pt-4 pb-4">
      <div className="flex items-center gap-3 mb-6">
        <button
          onClick={onBack}
          className="p-2 rounded-lg hover:bg-accent transition-colors duration-150"
          data-testid="about-back-button"
        >
          <ArrowLeft className="w-4 h-4 text-foreground" />
        </button>
        <h1 className="text-xl font-[var(--font-heading)] tracking-[-0.01em] text-foreground flex items-center gap-2">
          <BookOpen className="w-5 h-5 text-primary" />
          {t('about_nwt')}
        </h1>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        className="rounded-2xl border border-border bg-card p-6 shadow-sm"
      >
        <div className="w-16 h-20 rounded-xl bg-accent/50 flex items-center justify-center mx-auto mb-6">
          <BookOpen className="w-8 h-8 text-accent-foreground" />
        </div>

        <h2 className="text-lg font-[var(--font-heading)] text-center mb-4 whitespace-pre-line">
          {t('about_title')}
        </h2>
        <p className="text-xs text-center text-muted-foreground mb-6">{t('about_subtitle')}</p>

        <div className="space-y-4 text-sm leading-7 text-foreground/85">
          <p>{t('about_text')}</p>
          
          <h3 className="font-[var(--font-heading)] text-base mt-6 mb-2">{t('about_accuracy_title')}</h3>
          <p>{t('about_accuracy_text')}</p>

          <h3 className="font-[var(--font-heading)] text-base mt-6 mb-2">{t('about_clarity_title')}</h3>
          <p>{t('about_clarity_text')}</p>

          <h3 className="font-[var(--font-heading)] text-base mt-6 mb-2">{t('about_gods_name_title')}</h3>
          <p>{t('about_gods_name_text')}</p>

          <h3 className="font-[var(--font-heading)] text-base mt-6 mb-2">{t('about_languages_title')}</h3>
          <p>{t('about_languages_text')}</p>
        </div>

        <div className="mt-8 pt-4 border-t border-border">
          <p className="text-xs text-muted-foreground text-center">
            {t('about_learn_more')} <a href="https://wol.jw.org" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">wol.jw.org</a>
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default AboutSection;
